import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WishListContext } from "../../context/WishListProvider";
import "./ProductCard.css"; 
import { CartContext } from "../../context/CartProvider"; // Direct import of CartContext

const ProductCard = ({ item, categories }) => {
  // Using useContext directly with CartContext
  const { addToCart: addItemToCartContext, cart } = useContext(CartContext); 

  const [quantity, setQuantity] = useState(1); 
  
  const { addWishList, removeWishList, getExistingWishlist } = useContext(WishListContext);
  // const isAddedWishlist = getExistingWishlist(item?._id); 

  const isProductAdded = cart?.some(
    (cartItem) => cartItem.product_id === item._id
  );

  const calculateDiscount = (originalPrice, discountedPrice) => {
    if (!originalPrice || !discountedPrice || Number(originalPrice) === 0 || Number(originalPrice) <= Number(discountedPrice)) {
        return 0;
    }
    return Math.round(
      ((Number(originalPrice) - Number(discountedPrice)) / Number(originalPrice)) * 100
    );
  };

  const getCategoryName = (categoryId) => {
    const category = categories?.find((cat) => cat._id === categoryId);
    return category ? category.catagoryname.toUpperCase() : "CATEGORY";
  };

  const handleAddToCart = () => {
    const priceToUse = item?.attributes?.[0]?.other_attributes?.discount_price ||
                       item.discount_price ||
                       item.reguler_price;
    const stockAvailable = item?.attributes?.[0]?.other_attributes?.stock ?? item.stock;

    if (stockAvailable === 0 && !isProductAdded) { 
        console.warn("Attempted to add out-of-stock item:", item.product_name);
        return; 
    }
    
    const productToAdd = {
      product_id: item._id,
      product_name: item.product_name,
      price: priceToUse,
      productImage: item.productImage,
      stock: stockAvailable, 
      reguler_price: item.reguler_price,
      discount_price: item.discount_price,
      selectedAttributes: item?.attributes?.[0],
    };

    addItemToCartContext(productToAdd); // Calling context's addToCart function
  };

  useEffect(() => {
    setQuantity(1); 
  }, [item._id]);

  const discountPercentage = calculateDiscount(item.reguler_price, item.discount_price);
  const categoryName = getCategoryName(item.category);
  const currentStock = item?.attributes?.[0]?.other_attributes?.stock ?? item.stock;

  return (
    <div className="product-card">
      {discountPercentage > 0 && (
        <div className="discount-badge">
          {discountPercentage}% OFF
        </div>
      )}
      <div className="product-image-container">
        <img
          src={item.productImage || "https://placehold.co/200x200/e2e8f0/a0aec0?text=No+Image"}
          className="product-image"
          alt={item.product_name || "Product Image"}
          onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/200x200/e2e8f0/a0aec0?text=No+Image"; }}
        />
      </div>
      <div className="product-info">
        <div className="category-tag">{categoryName}</div>
        <h3 className="product-name">{item.product_name || "Product Name"}</h3>
        <div className="price-container">
          {item.discount_price && Number(item.discount_price) < Number(item.reguler_price) ? (
            <>
              <span className="current-price">£{item.discount_price}</span>
              <span className="original-price">£{item.reguler_price}</span>
            </>
          ) : (
            <span className="current-price">£{item.reguler_price || "N/A"}</span>
          )}
        </div>
        <div className="buttons-container">
          <Link
            to={`/product_details/${item._id}`} 
            className="details-button"
          >
            <i className="fas fa-eye"></i>
            <span>DETAILS</span>
          </Link>
          <button
            onClick={handleAddToCart} 
            disabled={currentStock === 0 && !isProductAdded} 
            className={`add-button ${isProductAdded ? 'added' : ''} ${currentStock === 0 && !isProductAdded ? 'disabled' : ''}`}
          >
            {isProductAdded ? (
              <>
                <i className="fas fa-check"></i>
                <span>ADDED</span>
              </>
            ) : (
              <>
                <i className="fas fa-shopping-cart"></i>
                <span>ADD</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
